/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: MRZ verification failed
 * @export
 * @interface PaxCheckMrzVerificationError
 */
export interface PaxCheckMrzVerificationError {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckMrzVerificationError
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckMrzVerificationError interface.
 */
export function instanceOfPaxCheckMrzVerificationError(value: object): value is PaxCheckMrzVerificationError {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckMrzVerificationErrorFromJSON(json: any): PaxCheckMrzVerificationError {
    return PaxCheckMrzVerificationErrorFromJSONTyped(json, false);
}

export function PaxCheckMrzVerificationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckMrzVerificationError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckMrzVerificationErrorToJSON(json: any): PaxCheckMrzVerificationError {
    return PaxCheckMrzVerificationErrorToJSONTyped(json, false);
}

export function PaxCheckMrzVerificationErrorToJSONTyped(value?: PaxCheckMrzVerificationError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

